import React, { useEffect, useState } from "react";
import {
  Button,
  Fade,
  Grid,
  Paper,
  Snackbar,
  TextField,
  Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useDispatch, useSelector } from "react-redux";
import { resetPassword } from "../../reduxState/aciton/authAction";
import { useNavigate } from "react-router-dom";
import MuiAlert from "@material-ui/lab/Alert";

const useStyle = makeStyles((theme) => ({
  background: {
    color: "#e6e6e6",
    margin: 0,
  },
  Paper: {
    width: "580px",
    marginTop: "10em",
    color: "#f6f6f6",
    borderRadius: "17px",
    padding: "2em",
  },
  Heading: {
    marginTop: "1em",
    fontSize: "1.3em",
    fontFamily: "Poppins, sans-serif",
    color: `${theme.palette.common.pink}`,
  },
  Link: { textDecoration: "none" },
  Button: {
    borderRadius: "20px",
    padding: "13px",
    backgroundColor: `${theme.palette.common.pink}`,
    color: "#fff",
    "&:hover": {
      backgroundColor: theme.palette.secondary.light,
    },
  },
}));

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function RestoredPassword() {
  const classes = useStyle();
  let navigate = useNavigate();

  // ***************************************state *********************************************
  const [formData, setformData] = useState({
    password: "",
  });
  const [validationHelper, setValidationHelper] = useState({
    passwordHelper: "",
  });
  const { password } = formData;
  const { passwordHelper } = validationHelper;

  // Snackbar
  const [openSanckbar, setOpenSnackbar] = useState({
    open: false,
    severity: "",
  });

  // *********************************OnChange handle**********************************************
  const onChange = (e) => {
    setformData({ ...formData, [e.target.name]: e.target.value });
  };

  // ***************************Redux State***************************
  const dispatch = useDispatch();
  const userPasswordStore = useSelector((state) => state.userPasswordStore);
  const { success, error: errorSuccess } = userPasswordStore;

  // ***************************Validation**************************

  const Validation = () => {
    let isError = true;

    if (password.length < 6) {
      isError = false;

      validationHelper.passwordHelper = "password must be greater than 6";
    }

    setValidationHelper({
      ...validationHelper,
    });

    return isError;
  };

  // *******************************onSubmit ******************************************************
  const onSubmit = (e) => {
    let err = Validation();

    if (err) {
      e.preventDefault();
      dispatch(resetPassword(password));
    }
  };

  // *************************************useEffect***********************************************
  useEffect(() => {
    if (success) {
      navigate("/Login");
    }
  }, [success, navigate]);

  // *************************************useEffect***********************************************
  useEffect(() => {
    if (errorSuccess) {
      setOpenSnackbar({
        open: true,
        severity: "error",
        message: errorSuccess
          ? errorSuccess?.data?.error
          : "Check you internet connection!",
      });
    }
  }, [errorSuccess]);

  return (
    <Grid item container className={classes.background} justify="center">
      <Grid
        item
        container
        component={Paper}
        elevation={3}
        className={classes.Paper}
        justify="center"
        alignItems="center"
      >
        <Grid
          item
          container
          justifyContent="center"
          className={classes.Heading}
        >
          <Typography variant="h4">Reset Paword</Typography>
        </Grid>
        <Grid item style={{ marginTop: "2em" }}>
          <Typography
            variant="subtitle1"
            style={{ textAlign: "-webkit-center" }}
          >
            Enter your new Passord
          </Typography>
        </Grid>
        <Grid
          item
          container
          direction="row"
          justify="center"
          alignItems="center"
          style={{ marginTop: "3em" }}
        >
          <Grid item container justify="center">
            <TextField
              id="password"
              variant="outlined"
              type="password"
              placeholder="Password"
              fullWidth
              inputProps={{
                style: {
                  padding: 13,
                  fontSize: "1.1rem",
                },
              }}
              name="password"
              value={password}
              error={passwordHelper.length !== 0}
              helperText={passwordHelper}
              onChange={onChange}
            />
          </Grid>

          <Grid
            item
            container
            justifyContent="center"
            style={{ marginTop: "3em" }}
          >
            <Button
              onClick={onSubmit}
              fullWidth
              variant="contained"
              className={classes.Button}
            >
              Reset
            </Button>
          </Grid>
        </Grid>
      </Grid>

      {/* ********************************Snackbar ********************************* */}
      <Snackbar
        open={openSanckbar.open}
        autoHideDuration={6000}
        TransitionComponent={Fade}
        onClose={() => {
          setOpenSnackbar({ open: false });
        }}
      >
        <Alert
          onClose={() => {
            setOpenSnackbar({ open: false });
          }}
          severity={openSanckbar.severity}
        >
          {openSanckbar.message}
        </Alert>
      </Snackbar>
    </Grid>
  );
}
export default RestoredPassword;
